<template>
  <div class="new-school-package">
    <i class="back" v-on:click="back"></i>
    <div class="activity-rule-img" v-on:click="showActivityRule"></div>
    <img class="pic" src="../../assets/images/parent_active/school_package_new/head_pic.png" />
    <div class="package">
      <img class="pic" src="../../assets/images/parent_active/school_package_new/term_package.png" />
      <div class="buy-button" v-on:click="buy(false)"></div>
    </div>
    <div class="package">
      <img class="pic" src="../../assets/images/parent_active/school_package_new/month_package.png" />
      <div class="buy-button" style="top: 2.6rem" v-on:click="buy(true)"></div>
    </div>
    <div class="intro-head"></div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in packageIntroList" :key="index">
          <img class="swiper-img" :src="item.image" />
        </div>
      </div>
      <div class="swiper-pagination swiper-pagination-bullets"></div>
    </div>
    <popup v-model="isShowRule">
      <div class="activity-rule">
        <div class="head">
          <img
            class="img"
            src="../../assets/images/parent_active/school_package/activity_rule_head.png"
          />
          <span class="text">活动说明</span>
        </div>
        <div class="content">
          <p>1、学习礼包为小盒家长为开学季推出的新型组合产品，开通后可立即开始享用礼包中提到的每一项服务，时长类服务会在原有剩余有效时长上继续叠加</p>
          <br />
          <p>2、本次礼包每日限额发放，每个用户限购一份</p>
          <br />
          <p>3、本次活动礼包中所有礼品皆为虚拟商品，购买后不支持退订</p>
          <br />
          <p>4、在购买和使用过程中遇到问题，请联系小盒家长客服：400-010-0180</p>
        </div>
      </div>
    </popup>
    <p v-if="toast" class="toast">{{toast}}</p>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import Popup from "../../components/common/schoolPackage_popup.vue";
import aja from "@/api/ajax";
import utils from "@/assets/js/utils";

const payHost = {
  test: "https://betassweb.knowbox.cn:7001",
  preview: "https://prefe.knowbox.cn:7001",
  production: "https://ssweb.knowbox.cn"
};
export default {
  components: {
    Popup
  },
  data() {
    return {
      packageIntroList: [
        {
          image: require("../../assets/images/parent_active/school_package_new/card_math.png"),
          jumpUrl: "hybird://method/openSyncMathSecondaryHomePage"
        },
        {
          image: require("../../assets/images/parent_active/school_package_new/card_chinese.png"),
          jumpUrl: "hybird://method/openSyncChineseSecondaryHomePage"
        },
        {
          image: require("../../assets/images/parent_active/school_package_new/card_english.png"),
          jumpUrl: "hybird://method/openSyncEnglishSecondaryHomePage"
        },
        {
          image: require("../../assets/images/parent_active/school_package_new/card_read.png"),
          jumpUrl: "hybird://method/openDreamReadHomePage"
        },
        {
          image: require("../../assets/images/parent_active/school_package_new/card_vip.png"),
          jumpUrl: ""
        },
        {
          image: require("../../assets/images/parent_active/school_package_new/card_idiom.png"),
          jumpUrl: "hybird://method/openIdiomMainPage?titleString=成语学堂"
        },
        {
          image: require("../../assets/images/parent_active/school_package_new/card_savantPlan.png"),
          jumpUrl: "hybird://method/openTSelectMap"
        }
      ],
      token: "",
      source: "",
      version: "",
      month: {},
      term: {},
      isShowRule: false,
      toast: ""
    };
  },
  mounted() {
    this.token = utils.getQueryString("token");
    this.source = utils.getQueryString("source");
    this.version = utils.getQueryString("version");
    this.getData();
    var swiper = new Swiper(".swiper-container", {
      pagination: ".swiper-pagination",
      bulletClass: "my-bullet",
      bulletActiveClass: "my-bullet-active",
      effect: "coverflow",
      loop: true,
      centeredSlides: true,
      slidesPerView: "auto",
      autoplay: 3000,
      autoplayDisableOnInteraction: false,
      coverflow: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: false
      },
      spaceBetween: 35
    });
  },
  methods: {
    back: function() {
      location.href = "hybird://method/exit";
    },
    getData: async function() {
      const [resp] = await aja.all([
        aja.get("https://ssapinew.knowbox.cn/html5/exercise/get-product-list", {
          params: {
            token: this.token,
            source: this.source,
            version: this.version
          }
        })
      ]);
      if (resp.data.code == 99999) {
        this.month = resp.data.data.month;
        this.term = resp.data.data.term;
      }
    },
    buy: function(isMonthPackage) {
      if (isMonthPackage) {
        if (!this.month.isCanBuy) {
          let self = this;
          self.toast = "每位用户限购1份";
          setTimeout(function() {
            self.toast = "";
          }, 1500);
          return;
        }
        if (this.source.search("android") != -1) {
          window.location =
            "hybird://method/openPayment?productId=" +
            this.month.productId +
            "&discountPrice=30&comeFrom=1&withDiscount=false&productName=【套餐2：语数英同步练各30天】&productSubTitle=加赠阅读月卡等4项学习产品&comeFrom=23";
        } else {
          window.location = `${
            payHost[process.env.VUE_APP_INTER]
          }/h5-pay/dist/production/pay-final.html?token=${this.token}&source=${
            this.source
          }&version=${
            this.version
          }&payList=["wx_wap","alipay_wap"]&title=${encodeURIComponent(
            "【套餐2：语数英同步练各30天】"
          )}&subTitle=${encodeURIComponent(
            "加赠阅读月卡等4项学习产品"
          )}&payPath=/ss/vip/pay-vip&verifyPath=/ss/vip/pay-verify&lastPay=wx_wap&productId=${
            this.month.productId
          }&isShowMoney=2&isElephantCourse=0`;
        }
      } else {
        if (!this.term.isCanBuy) {
          let self = this;
          self.toast = "每位用户限购1份";
          setTimeout(function() {
            self.toast = "";
          }, 1500);
          return;
        }
        this.$router.push({
          path:
            "/parentActive/package-select-dot-read?token=" +
            this.token +
            "&source=" +
            this.source +
            "&version=" +
            this.version +
            "&price=98&originPrice=1386" +
            "&productId=" +
            this.term.productId
        });
      }
    },
    showActivityRule: function() {
      this.isShowRule = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.new-school-package {
  background: #ff9c15;
  min-height: 100vh;
  .back {
    position: fixed;
    z-index: 100;
    left: 0.35rem;
    top: 0.66rem;
    width: 0.6rem;
    height: 0.6rem;
    background: url("../../assets/images/common/back.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .activity-rule-img {
    position: absolute;
    z-index: 100;
    top: 0.8rem;
    right: 0.3rem;
    width: 1.24rem;
    height: 0.43rem;
    background: url("../../assets/images/parent_active/school_package_new/activity_rule.png") no-repeat;
    background-size: 100%;
  }
  .pic {
    width: 100%;
  }
  .package {
    position: relative;
    .buy-button {
      position: absolute;
      z-index: 10;
      width: 1.57rem;
      height: 0.88rem;
      top: 2.9rem;
      right: 0.66rem;
      background: url("../../assets/images/parent_active/school_package_new/buy_button.png")
        no-repeat;
      background-size: 100%;
    }
  }
  .intro-head {
    width: 5.17rem;
    height: 0.9rem;
    margin: 0 auto;
    background: url("../../assets/images/parent_active/school_package_new/intro_head.png")
      no-repeat;
    background-size: 100%;
  }
  .swiper-container {
    position: relative;
    z-index: 0;
    width: 100%;
    padding-top: 0.48rem;
    padding-bottom: 0.65rem;
    .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 75%;
      .swiper-img {
        width: 100%;
      }
    }
  }
  .activity-rule {
    width: 6.52rem;
    height: 5.7rem;
    margin-top: 50%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    .head {
      display: flex;
      flex-direction: column;
      align-items: center;
      .img {
        position: absolute;
        z-index: 0;
        width: 3.76rem;
        height: 0.82rem;
      }
      .text {
        position: absolute;
        z-index: 1;
        font-family: pingFangSc-Medium;
        font-size: 0.42rem;
        color: #e45866;
        margin-top: 0.05rem;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      background: #fff;
      width: 100%;
      height: 4.8rem;
      margin-top: 0.46rem;
      padding-top: 0.6rem;
      padding-left: 0.45rem;
      padding-right: 0.4rem;
      border-radius: 0.3rem;
      font-size: 0.24rem;
      color: #4f596b;
    }
  }
}
</style>
<style>
.my-bullet {
  display: inline-block;
  height: 0.14rem;
  width: 0.14rem;
  background: #ffd1a0;
  position: relative;
  margin: 0 0.1rem;
  border-radius: 0.1rem;
}
.my-bullet-active {
  background: #fffde7;
  height: 0.2rem;
  width: 0.2rem;
  opacity: 1;
}
</style>